<template>
    <v-input v-model="localValue" class="day-selector" 
        :rules="[v => !required || !!v.length || errorMessage]">
        <div style="width: 100%">
            <fe-label>Day(s) of the Week</fe-label>
            <div class="d-flex" :class="{'day-selector-adjusted': threeLetter ? true : false}">
                <div v-for="(day, index) in days"
                    @click="toggleDay(day)"
                    class="day-select text-no-select"
                    :class="[{'day-select-selected': localValue && !secondary ? isSelected(day) : false}, 
                        {'day-select-adjust-width': threeLetter ? true : false}, 
                        {'day-select-secondary': localValue && secondary ? isSelected(day) : false},
                        {'day-select-last': index === days.length - 1}]"
                ><v-icon v-if="localValue && secondary && isSelected(day)" class="mr-2">fal fa-check</v-icon>{{day.name}}</div>
            </div>
        </div>
    </v-input>
</template>

<script>
    export default {
        name: 'WeekdayPicker',
        props: {
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false,
            },
            threeLetter: {
                type: Boolean,
                default: false
            },
            secondary: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: null
            },
        },
        computed: {
            errorMessage() {
                if(this.error) return this.error
                return this.secondary ? 'Select the day(s) of the week when the measure will be given.' : 'Select at least one day'
            }
        },
        watch: {
            value: {
                handler(v) {
                    if (v) {
                        this.localValue = v
                    } else {
                        this.localValue = ''
                    }
                },
                immediate: true
            }
        },
        data() {
            return {
                localValue: '',
                days: [{
                    id: 'M',
                    name: 'M'
                }, {
                    id: 'T',
                    name: 'Tu'
                }, {
                    id: 'W',
                    name: 'W'
                }, {
                    id: 'H',
                    name: 'Th'
                }, {
                    id: 'F',
                    name: 'F'
                }]
            }
        },
        created() {
            if(this.threeLetter) {
                this.days = [{
                        id: 'M',
                        name: 'Mon'
                    }, {
                        id: 'T',
                        name: 'Tue'
                    }, {
                        id: 'W',
                        name: 'Wed'
                    }, {
                        id: 'H',
                        name: 'Thu'
                    }, {
                        id: 'F',
                        name: 'Fri'
                    }]
            }
        },
        methods: {
            isSelected(day) {
                return this.localValue.toLowerCase().indexOf(day.id.toLowerCase()) == -1 ? false : true
            },
            toggleDay(day) {
                let f = this.localValue.toLowerCase().indexOf(day.id.toLowerCase())==-1 ? false : true
                if (f) {
                    this.localValue = this.localValue.replace(day.id, '')
                } else {
                    this.localValue+=day.id
                }
                this.$emit('input', this.localValue.toUpperCase())
            }
        }
    }
</script>

<style lang="scss" scoped>
.day-selector {
    margin-left: -8px;

    &-adjusted {
        width: 103%;
        justify-content: space-between;
    }

    ::v-deep .v-input__slot {
        margin-bottom: 4px !important;
    }
}
.day-selector::v-deep .v-messages__wrapper {
    padding-left: 9px;
}
.day-select {
    cursor: pointer;
    border: 1px solid #C0C3CF;
    box-sizing: border-box;
    border-radius: 4px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    margin: 4px 8px 4px 0px;

    &-selected {
        color: white;
        background-color: var(--v-primary-base);
    }

    &-secondary {
        border: 1px solid #80B6C7;
        background: #E5F0F4;
        .error-text {
            border: 1px solid #BF0D00 !important;
        }
    }

    &-adjust-width {
        min-width: 75px;
        flex-grow: 1;
        margin: 4px 12px 4px 0px;
    }

    &-last {
        margin: 4px 0px 4px 0px;
    }
}
</style>
